import CLIENT from 'af-routes/client';

export const BREADCRUMBS = [
	{ label: 'Companies', url: CLIENT.ORGANIZATION.COMPANIES() },
	{ label: 'Revenue overview notifications' },
];
